import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2.01v16H22V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
}), 'LocalPostOfficeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalPostOfficeSharp.js
// module id = 4649
// module chunks = 2